/* eslint-disable */
export default function initCookieConsent() {
  if (typeof CookieConsent === 'undefined') {
    console.error('CookieConsent library not loaded');
    return;
  }

  CookieConsent.run({
    disablePageInteraction: true,
    guiOptions: {
      consentModal: {
        layout: 'box',
        position: 'bottom right',
        equalWeightButtons: true,
        flipButtons: false,
      },
      preferencesModal: {
        layout: 'box',
        position: 'right',
        equalWeightButtons: true,
        flipButtons: false,
      },
    },
    categories: {
      necessary: {
        readOnly: true,
      },
      analytics: {},
    },
    language: {
      default: 'fr',
      autoDetect: 'document',
      translations: {
        fr: {
          consentModal: {
            title: 'Nous utilisons des cookies !',
            description:
              'Nous utilisons des cookies pour améliorer votre expérience sur Sage, analyser le trafic, et personnaliser le contenu. Vous pouvez choisir les types de cookies que vous acceptez.',
            acceptAllBtn: 'Tout accepter',
            acceptNecessaryBtn: 'Tout rejeter',
            showPreferencesBtn: 'Gérer les préférences',
            footer:
              '<a href="#link">Politique de confidentialité</a>\n<a href="#link">Termes et conditions</a>',
          },
          preferencesModal: {
            title: 'Préférences de cookies',
            acceptAllBtn: 'Tout accepter',
            acceptNecessaryBtn: 'Tout rejeter',
            savePreferencesBtn: 'Sauvegarder les préférences',
            closeIconLabel: 'Fermer la modale',
            serviceCounterLabel: 'Services',
            sections: [
              {
                title: 'Utilisation des Cookies',
                description:
                  'Sur Sage, nous utilisons des cookies pour garantir le bon fonctionnement du site, collecter des statistiques, et personnaliser votre expérience.',
              },
              {
                title:
                  'Cookies Strictement Nécessaires <span class="pm__badge">Toujours Activé</span>',
                description:
                  'Ces cookies sont essentiels pour le bon fonctionnement de Sage. Ils ne peuvent pas être désactivés.',
                linkedCategory: 'necessary',
              },
              {
                title: 'Cookies Analytiques',
                description:
                  "Ces cookies nous aident à comprendre comment vous utilisez Sage afin d'améliorer nos services.",
                linkedCategory: 'analytics',
              },
              {
                title: "Plus d'informations",
                description:
                  'Pour toute question concernant notre politique de cookies et vos choix, veuillez <a class="cc__link" href="#yourdomain.com">nous contacter</a>.',
              },
            ],
          },
        },
        en: {
          consentModal: {
            title: 'We use cookies!',
            description:
              'We use cookies to enhance your experience on Sage, analyze traffic, and personalize content. You can choose which types of cookies you want to accept.',
            acceptAllBtn: 'Accept all',
            acceptNecessaryBtn: 'Reject all',
            showPreferencesBtn: 'Manage preferences',
            footer:
              '<a href="#link">Privacy Policy</a>\n<a href="#link">Terms and Conditions</a>',
          },
          preferencesModal: {
            title: 'Cookie Preferences',
            acceptAllBtn: 'Accept all',
            acceptNecessaryBtn: 'Reject all',
            savePreferencesBtn: 'Save preferences',
            closeIconLabel: 'Close modal',
            serviceCounterLabel: 'Services',
            sections: [
              {
                title: 'Use of Cookies',
                description:
                  'On Sage, we use cookies to ensure the website functions correctly, collect statistics, and personalize your experience.',
              },
              {
                title:
                  'Strictly Necessary Cookies <span class="pm__badge">Always Active</span>',
                description:
                  'These cookies are essential for Sage to function properly and cannot be turned off.',
                linkedCategory: 'necessary',
              },
              {
                title: 'Analytics Cookies',
                description:
                  'These cookies help us understand how you use Sage so we can improve our services.',
                linkedCategory: 'analytics',
              },
              {
                title: 'More information',
                description:
                  'For any queries regarding our cookie policy and your choices, please <a class="cc__link" href="#yourdomain.com">contact us</a>.',
              },
            ],
          },
        },
      },
    },
  });
}
